// @ts-ignore
import { v4 as uuidV4 } from 'uuid'

const LOCAL_ID_KEY = 'LOCAL_ID_KEY';
const SESSION_ID_KEY = 'SESSION_ID_KEY';
const EVENT_REPORT_NO_KEY = 'EVENT_REPORT_NO_KEY';

export class Storage {
    get localID(): string {
        let id = localStorage.getItem(LOCAL_ID_KEY)
        if (id) { return id }

        id = uuidV4()
        localStorage.setItem(LOCAL_ID_KEY, id)
        return id
    }

    get sessionID(): string {
        let id = sessionStorage.getItem(SESSION_ID_KEY)
        if (id) { return id }

        id = uuidV4()
        sessionStorage.setItem(SESSION_ID_KEY, id)
        return id
    }

    get eventReportNo(): number {
        let value = sessionStorage.getItem(EVENT_REPORT_NO_KEY)
        let numValue = parseInt(value || '0', 10)
        if (isNaN(numValue)) {
            sessionStorage.setItem(EVENT_REPORT_NO_KEY, '0')
            return 0
        }

        return numValue
    }

    set eventReportNo(value: number) {
        sessionStorage.setItem(EVENT_REPORT_NO_KEY, value.toString())
    }
}
